import { CUSTOM_PART_NUMBER } from '../components/QuoteProductsTable/constants';
import { Language, StandardType } from '../enums';
import { Cable, QuoteProduct } from '../models';

export const getDefaultQuoteProduct = (
  custom: boolean,
  count: number
): QuoteProduct => {
  return {
    id: custom ? CUSTOM_PART_NUMBER : '',
    description: '',
    discount: 0,
    isCSA: true,
    isUL: true,
    lineItem: (count || 0) + 1,
    materialType: null,
    minimumOrderQuantity: 0,
    normalizedId: custom ? CUSTOM_PART_NUMBER : '',
    partNumber: custom ? CUSTOM_PART_NUMBER : '',
    price: 0,
    productType: null,
    quantity: 0,
    standardLeadTime: {
      [Language.English]: '',
      [Language.French]: '',
    },
    standardType: StandardType.Unspecified,
  };
};

export const updateQuoteProductFromCable = (
  product: QuoteProduct,
  cable: Cable
) => {
  const updatedProduct = {
    ...product,
    normalizedId: cable.id,
    partNumber: cable.id,
  };
  Object.assign(updatedProduct, cable);
  if (!cable.specsFileUrl) delete updatedProduct.specsFileUrl;

  return updatedProduct;
};

export function isQuoteProductValid(product: QuoteProduct) {
  return !!product?.partNumber;
}
